import moment, { Moment } from 'moment';

const getMomentObject = (input: string, format: string): Moment => moment(input, format);

export default getMomentObject;
